import { useMemo, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import UITourCancelButton from 'ui-shepherd-react/button/UITourCancelButton';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { cleanupLinkedTour } from '../../util/linkedTourUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OnboardingTourCloseModal = ({
  onConfirm,
  onReject,
  tourId,
  stepId,
  'data-test-id': dataTestId,
  rootNode,
  modalConfig
}) => {
  const trackingMethod = useTourTrackingMethod('trackTourViewCloseModal');
  const trackTourViewCloseModal = useMemo(() => trackingMethod || (() => {}), [trackingMethod]);
  useEffect(() => {
    trackTourViewCloseModal(tourId, stepId, 'open tour close modal');
  }, [stepId, tourId, trackTourViewCloseModal]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": dataTestId,
    rootNode: rootNode,
    use: "conversational",
    children: [/*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockStart: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        textAlign: "start",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.title"
        })
      }), (modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig.description) && /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "600",
        paddingInline: "1000",
        textAlign: "start",
        children: modalConfig.description
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(UITourCancelButton, {
        "data-test-id": "onboarding-tour-close-confirm-button",
        onClick: () => {
          trackTourViewCloseModal(tourId, stepId, 'confirm closing tour');
          onConfirm();
          cleanupLinkedTour();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.confirm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "onboarding-tour-close-reject-button",
        onClick: () => {
          trackTourViewCloseModal(tourId, stepId, 'reject closing tour');
          onReject();
        },
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.reject"
        })
      })]
    })]
  });
};
export default OnboardingTourCloseModal;